/**
 * Cortex Analytics Service
 * ========================
 * Client for fetching Cortex Analytics data (cached or fresh).
 * Used by the Cortex dashboard and preloaded on login.
 *
 * Usage:
 * ```javascript
 * import { getCortexAnalytics } from '../services/cortexAnalytics';
 *
 * // Get cached data (or compute if first time)
 * const data = await getCortexAnalytics();
 *
 * // Force refresh
 * const fresh = await getCortexAnalytics(true);
 * ```
 */

import { getApiUrl } from '../api/config';

const getCortexUrl = () => `${getApiUrl()}/cortex/analytics`;
console.log("cortexturl", getCortexUrl)
/**
 * Fetch Cortex Analytics data.
 * @param {boolean} refresh - If true, forces recomputation. Default false.
 * @returns {Promise<Object>} Analytics data with heatmap_data, discipline_tracker,
 *   emotion_outcome, rule_breaking_feed, badges, computed_at
 */
export async function getCortexAnalytics(refresh = false) {
  const token = localStorage.getItem('access_token');
  if (!token) {
    throw new Error('Not authenticated');
  }

  const response = await fetch(getCortexUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ refresh }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Failed to fetch Cortex Analytics: ${response.status}`);
  }

  return response.json();
}
